import { render } from "./MembroCampoInfo.vue?vue&type=template&id=3f035fd6&scoped=true"
import script from "./MembroCampoInfo.vue?vue&type=script&lang=js"
export * from "./MembroCampoInfo.vue?vue&type=script&lang=js"

import "./MembroCampoInfo.vue?vue&type=style&index=0&id=3f035fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f035fd6"]])

export default __exports__